import { ReactNode } from 'react'

import {
  Text,
  GreyGrey60,
  Primary13Regular,
  Box,
  Flex
} from '@sequencehq/core-components'

export const SummaryRow = ({
  label,
  value
}: {
  label: string
  value: ReactNode
}) => (
  <Flex height="28px" alignItems="center" alignContent="center">
    <Box width="140px">
      <Text {...Primary13Regular} color={GreyGrey60}>
        {label}
      </Text>
    </Box>
    {value}
  </Flex>
)
